import { createPortal } from 'react-dom';
import { X, Check, CircleAlert } from 'lucide-react';

// row-by-row validation result of the Excel/CSV template import
export default function ImportReview({ t, res, onImport, onClose }) {
  const ok = res.rows.filter((r) => r.fit), bad = res.rows.filter((r) => !r.fit);
  return createPortal(
    <div className="editor-backdrop" data-testid="import-review" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="editor imp-rev">
        <div className="editor-head">
          <h4>📊 {t.impRevTitle}</h4>
          <button className="icon-btn" data-testid="import-review-close-btn" onClick={onClose}><X size={18} /></button>
        </div>
        <p data-testid="import-review-summary"><b className="ok">✅ {ok.length} {t.impRevOk}</b> · <b className="bad">❌ {bad.length} {t.impRevBad}</b> · {res.rows.length} {t.impRevRows}</p>
        <div className="imp-rev-list">
          {res.rows.map((r) => (
            <div key={r.n} className={`imp-row ${r.fit ? 'ok' : 'bad'}`} data-testid={`import-row-${r.n}`}>
              <span className="mono">{t.impRow} {r.n}</span>
              <span>{r.id || '–'} · {r.cat || '–'}</span>
              {r.fit ? <span><Check size={13} /> {t.impRowOk}</span> : <span data-testid={`import-row-${r.n}-errors`}><CircleAlert size={13} /> {r.errors.map((e) => t['impE_' + e]).join(' · ')}</span>}
            </div>
          ))}
        </div>
        <div className="row">
          <button className="btn btn-green" data-testid="import-review-confirm-btn" disabled={!ok.length} onClick={() => onImport(ok.map((r) => r.fit))}><Check size={16} /> {ok.length} {t.impRevDo}</button>
          <button className="btn btn-outline" data-testid="import-review-cancel-btn" onClick={onClose}>{t.cancel}</button>
        </div>
        {bad.length > 0 && <small className="muted">{t.impRevHint}</small>}
      </div>
    </div>,
    document.body,
  );
}
